import React, { useContext } from 'react'
import DiagnosticImage from '../../../assets/Images/Data/diagnostic_image.svg'
import QuienesResponden from '@BUP/assets/Images/Data/data_¿quienes-responden.svg'
import Duracion from '@BUP/assets/Images/Data/data_¿duracion.svg'
import QueMide from '@BUP/assets/Images/Data/data_¿que-mide.svg'
import { useTranslation } from 'react-i18next'
import styles from './data-page-student.module.scss'
import PageLayout from '@BUP/components/Layout/Page'
import IsParticipantComponent from '@BUP/components/Data/IsParticipantComponent'
import InfoCard from '@BUP/components/Generics/Cards/InfoCard'
import InfoCardItem from '@BUP/components/Generics/Cards/InfoCardItem'
import InfoInstrumentCard from '@BUP/components/Generics/Cards/InstrumentCard/info-instrument-card'
import { OrganizationContext } from '@BUP/contexts/OrganizationContext'

const DataPageStudent = () => {
  const [t] = useTranslation()
  const organization = useContext(OrganizationContext)
  const locationName = organization.location.name

  return (
    <PageLayout pageName='BRAVE UP! DATA'>
      <p className={styles.intro_text}>
        {t('pages.data.instruments.student.introText')}
      </p>
      <div className={styles.instruments_container}>
        <IsParticipantComponent />
        <InfoCard title={t('pages.data.instruments.student.sociogram.title')}>
          <InfoCardItem
            img={Duracion}
            title={t('pages.data.instruments.student.sociogram.question1')}
            description={t('pages.data.instruments.student.sociogram.answer1')}
          />
          <InfoCardItem
            img={QuienesResponden}
            title={t('pages.data.instruments.student.sociogram.question2')}
            description={t(
              'pages.data.instruments.student.sociogram.answer2'
            )}
          />
          <InfoCardItem
            img={QueMide}
            title={t('pages.data.instruments.student.sociogram.question3')}
            description={t('pages.data.instruments.student.sociogram.answer3')}
          />
        </InfoCard>
        <InfoInstrumentCard
          srcImage={DiagnosticImage}
          title={t('pages.data.instruments.student.diagnosis.title')}
          description={t('pages.data.instruments.student.diagnosis.description')}
        />
        <InfoCard title={t('pages.data.instruments.student.diagnosis.title')}>
          <InfoCardItem
            img={Duracion}
            title={t('pages.data.instruments.student.diagnosis.question1')}
            description={t('pages.data.instruments.student.diagnosis.answer1')}
          />
          <InfoCardItem
            img={QuienesResponden}
            title={t('pages.data.instruments.student.diagnosis.question2')}
            description={
              locationName === 'Colombia' || locationName === 'Mexico' || locationName === 'Peru' ? t('pages.data.instruments.student.diagnosis.alternativeAnswer2') : t('pages.data.instruments.student.diagnosis.answer2')
            }
          />
          <InfoCardItem
            img={QueMide}
            title={t('pages.data.instruments.student.diagnosis.question3')}
            description={t(
              'pages.data.instruments.student.diagnosis.answer3'
            )}
          />
        </InfoCard>
      </div>
    </PageLayout>
  )
}

export default DataPageStudent
